
import { useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useSessionManagement = () => {
  // Refresh session handler with retry logic
  const refreshSession = useCallback(async (): Promise<boolean> => {
    try {
      console.log("Attempting to refresh session");
      const { data, error } = await supabase.auth.refreshSession();
      
      if (error) {
        console.error("Error refreshing session:", error);
        throw error;
      }
      
      if (data.session) {
        console.log("Session refreshed successfully, expires at:", 
          new Date(data.session.expires_at! * 1000).toLocaleString());
        return true;
      }
      
      console.warn("Session refresh returned no session");
      return false;
    } catch (error) {
      console.error("Exception refreshing session:", error);
      return false;
    }
  }, []);

  return {
    refreshSession
  };
};
